import styled from 'styled-components';

export default styled.span`
  max-width: 215px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
`;
